import React from 'react';
import { Form, Input, Modal, ModalProps, Typography } from 'antd';
import { FloatingFormItem } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { useDuplicateProfile } from '@/core/domain/enterprise/Profiles/Profiles.hooks';
import { useHistory } from 'react-router-dom';

interface Props extends Omit<ModalProps, 'onCancel' | 'onOk'> {
  onCancel: () => void;
  profileId?: number;
  profileName?: string;
}

const DuplicateProfilesModal: React.FC<Props> = ({
  open,
  onCancel,
  profileId,
  profileName = '',
}) => {
  const history = useHistory();

  const [form] = Form.useForm<{ name: string }>();
  const duplicateName = Form.useWatch('name', form);

  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const duplicateProfile = useDuplicateProfile();

  const handleOk = async () => {
    if (duplicateName && profileId) {
      const response = await duplicateProfile.mutateAsync({
        id: profileId,
        name: duplicateName,
      });

      if (response) {
        handleCancel();
        form.resetFields();
        history.push(`/app/settings/profiles/${response.id}`);
      }
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      open={open}
      confirmLoading={duplicateProfile.isLoading}
      onCancel={handleCancel}
      title={`Replicando grupo ${profileName}`}
      onOk={handleOk}
      okText="Replicar"
      destroyOnClose={!open}
    >
      <Form form={form} preserve={false}>
        <Typography.Title level={5}>Nome do novo grupo</Typography.Title>

        <FloatingFormItem
          name="name"
          label="Nome"
          rules={[defaultEmptyFieldError]}
        >
          <Input />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
};

export default DuplicateProfilesModal;
